import React, { useState, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Spinner from "../layout/Spinner";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Pagination from "../layout/Pagination";
import {
  getModifiedSampadaProductReport,
  getBatchOfParish,
  getCategoryAndSubcategory,
} from "../../actions/shg";
import { getVarados, getParish } from "../../actions/area";
import { CSVLink } from "react-csv";

const ProductReport = ({
  auth: { isAuthenticated, user, users },
  area: { varadosData, activeParish },
  shg: { newsampadaProductReport, loadStatus, categoryandSubcategory },
  getVarados,
  getParish,
  getBatchOfParish,
  getModifiedSampadaProductReport,
  getCategoryAndSubcategory,
}) => {
  useEffect(() => {
    getModifiedSampadaProductReport();
  }, [getModifiedSampadaProductReport]);

  useEffect(() => {}, [loadStatus]);
  useEffect(() => {
    getCategoryAndSubcategory();
  }, [getCategoryAndSubcategory]);

  const data =
    newsampadaProductReport && newsampadaProductReport
      ? newsampadaProductReport
      : "";

  useEffect(() => {
    getVarados();
  }, [getVarados]);

  const allvarado = [];
  varadosData.map((varado) =>
    allvarado.push({
      vId: varado._id,
      vCode: varado.varadoCode,
      label: varado.varadoName,
      value: varado.varadoName,
    }),
  );

  const [varado, getVaradoData] = useState("");
  const onVaradoChange = async (e) => {
    getVaradoData(e);
    let varadoVal = {
      varadoInfo: e.vId,
    };
    getParish(varadoVal);
    getParishData("");
    getBatchOfParish("");
    getModifiedSampadaProductReport({ varadoVal: e.vId, varadoName: e.value });
    setCurrentData(1);
    localStorage.setItem("PageIndexs", 1);
  };

  const allparish = [];
  activeParish.map((parish) =>
    allparish.push({
      pId: parish._id,
      pCode: parish.parishCode,
      bCounter: parish.batchCounter,
      label: parish.parishName,
      value: parish.parishName,
    }),
  );

  const [parish, getParishData] = useState("");
  const onParishChange = async (e) => {
    getParishData(e);
    var filterData = {
      parishId: e.pId,
    };
    getBatchOfParish(filterData);
    getModifiedSampadaProductReport({
      varadoVal: varado.vId,
      varadoName: varado.value,
      parishId: e.pId,
      parishName: e.value,
    });
    setCurrentData(1);
    localStorage.setItem("PageIndexs", 1);
  };

  //pagination code
  if (JSON.parse(localStorage.getItem("PageIndexs")) === null) {
    localStorage.setItem("PageIndexs", 1);
  }
  const [currentData, setCurrentData] = useState(
    JSON.parse(localStorage.getItem("PageIndexs")),
  );
  const [dataPerPage] = useState(10);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas = data && data.slice(indexOfFirstData, indexOfLastData);
  //change page

  const paginate = (nmbr) => {
    localStorage.setItem("PageIndexs", nmbr);
    setCurrentData(nmbr);
  };

  const grouped =
    currentDatas &&
    currentDatas.reduce((acc, item) => {
      const products = item.productDetails || [];

      if (!acc[item.name]) {
        acc[item.name] = {
          parish: item.parishName,
          varado: item.varadoName,
          batchId: item.batchName,
          phone: item.phone,
          products: [],
        };
      }
      acc[item.name].products.push(...products);

      return acc;
    }, {});

  const getCategoryName = (id) => {
    const category =
      categoryandSubcategory &&
      categoryandSubcategory.categoryInfo &&
      categoryandSubcategory.categoryInfo.find((cat) => cat._id === id);
    return category ? category.category : "";
  };
  const getSubCategoryName = (id) => {
    const Subcategory =
      categoryandSubcategory &&
      categoryandSubcategory.subcategoryInfo &&
      categoryandSubcategory.subcategoryInfo.find((scat) => scat._id === id);
    return Subcategory ? Subcategory.subcategory : "";
  };

  const handleReset = () => {
    getParishData("");
    getVaradoData("");
    getParish("");
    getBatchOfParish("");
    getModifiedSampadaProductReport("");
    setCurrentData(1);
    localStorage.removeItem("PageIndexs");
  };

  const csvData = [
    [
      "Member Name",
      "Parish",
      "Varado",
      "Batch",
      "Phone",
      "Product Name",
      "Variant",
      "Brand Name",
      "Category",
      "Sub Category",

      "Unit Value",
      "Unit",
      "Sub Unit Value",
      "Sub Unit",
      "Price",

      "Product Status",
      "Tag",
      "Shelf Life",
      "Product Details",
      "Ingredients",
      "Usage",
    ],
  ];

  if (data) {
    data &&
      data.forEach((item) => {
        item.productDetails.forEach((ele, index) => {
          csvData.push([
            index === 0 ? item.name : "",
            index === 0 ? item.parishName : "",
            index === 0 ? item.varadoName : "",
            index === 0 ? item.batchName : "",
            index === 0 ? item.phone : "",
            ele.pName,
            ele.variant,
            ele.brandName,
            getCategoryName(ele.categoryId),
            getSubCategoryName(ele.subcategoryId),
            (ele && ele.quantity.map((e) => e.unitValue).join(", ")) || "",
            (ele && ele.quantity.map((e) => e.unit).join(", ")) || "",
            (ele && ele.quantity.map((e) => e.subunitValue).join(", ")) || "",
            (ele &&
              ele.quantity
                .map((e) => (e.subUnit == "" ? "-" : e.subUnit))
                .join(", ")) ||
              "",
            (ele && ele.quantity.map((e) => e.price).join(", ")) || "",

            ele.pStatus,
            ele.tag,
            Number(ele.shelfLife.from) === Number(ele.shelfLife.to)
              ? `${ele.shelfLife.from || ""} ${ele.shelfLife.days || ""}`
              : `${ele.shelfLife.from || ""} - ${ele.shelfLife.to || ""} ${ele
                  .shelfLife.days || ""}`,
            ele.productDetails,
            ele.ingredients,
            ele.usage,
          ]);
        });
      });
  }

  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      {loadStatus ? (
        <Spinner />
      ) : (
        <div className="container container_align ">
          <div className="col-lg-11 col-md-11 col-sm-11 col-11">
            <h2 className="heading_color">Modified Product Report </h2>
            <hr />
          </div>
          <section className="sub_reg">
            <div className="row col-lg-11 col-md-11 col-sm-11 col-11 no_padding">
              <>
                <div
                  className="col-lg-3 col-md-3 col-sm-3 col-11 mt-1"
                  style={{ zIndex: "999" }}
                >
                  <Select
                    name="varadoName"
                    options={allvarado}
                    isSearchable={true}
                    value={varado}
                    placeholder="Select Varado"
                    onChange={(e) => onVaradoChange(e)}
                  />
                </div>

                <div className="col-lg-3 col-md-3 col-sm-3 col-11 mt-1">
                  <Select
                    name="parishName"
                    options={allparish}
                    isSearchable={true}
                    value={parish}
                    placeholder="Select Parish"
                    onChange={(e) => onParishChange(e)}
                  />
                </div>
              </>

              <div className="col-lg-3 col-md-3 col-sm-3 col-11 mt-1"></div>

              <div className="col-lg-12 col-md-3 col-sm-4 col-11 py-3">
                <Link to="/all-reports">
                  <img
                    className="img_icon_size log float-right ml-3"
                    src={require("../../static/images/back.png")}
                    onClick={() => localStorage.removeItem("PageIndexs")}
                    alt="Back"
                    title="Back"
                  />
                </Link>
                <img
                  className="img_icon_size log float-right ml-3"
                  onClick={() => handleReset()}
                  src={require("../../static/images/refresh-icon.png")}
                  alt="refresh"
                  title="Refresh"
                />

                <CSVLink data={csvData} filename="ModifiedProductReport.csv">
                  <img
                    className="img_icon_size log float-right ml-4"
                    src={require("../../static/images/ExcelIcon.png")}
                    alt="Excel-Export"
                    title="Excel-Export"
                  />
                </CSVLink>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-11 col-md-11 col-sm-11 col-11 text-center ">
                <section className="body">
                  <div className=" body-inner no-padding table-responsive table-container ">
                    <table
                      className="table table-bordered table-striped table-hover"
                      id="datatable2"
                    >
                      <thead>
                        <tr>
                          <th className="sticky-col">Member Name</th>
                          <th>Parish</th>
                          <th>Varado</th>
                          <th>Batch</th>
                          <th>Phone</th>
                          <th>Product Name</th>
                          <th>Variant</th>
                          <th>Brand Name</th>
                          <th>Category</th>
                          <th>Sub Category</th>

                          <th>Unit Value</th>
                          <th>Unit</th>
                          <th>Sub Unit Value</th>
                          <th>Sub Unit</th>
                          <th>Price</th>

                          <th>Product Status</th>
                          <th>Tag</th>
                          <th>Shelf Life</th>
                          <th>Product Details</th>
                          <th>Ingredients</th>
                          <th>Usage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(grouped).map(([name, data]) =>
                          data.products.map((ele, i) => (
                            <tr key={i}>
                              {i === 0 && (
                                <>
                                  <td
                                    rowSpan={data.products.length}
                                    className="sticky-col"
                                  >
                                    {name}
                                  </td>
                                  <td rowSpan={data.products.length}>
                                    {data.parish}
                                  </td>
                                  <td rowSpan={data.products.length}>
                                    {data.varado}
                                  </td>

                                  <td rowSpan={data.products.length}>
                                    {data.batchId}
                                  </td>
                                  <td rowSpan={data.products.length}>
                                    {data.phone}
                                  </td>
                                </>
                              )}

                              <td>{ele.pName}</td>
                              <td>{ele.variant}</td>
                              <td>{ele.brandName}</td>
                              <td>{getCategoryName(ele.categoryId)}</td>
                              <td>{getSubCategoryName(ele.subcategoryId)}</td>
                              <td>
                                {(ele &&
                                  ele.quantity
                                    .map((e) => e.unitValue)
                                    .join(", ")) ||
                                  ""}
                              </td>
                              <td>
                                {(ele &&
                                  ele.quantity.map((e) => e.unit).join(", ")) ||
                                  ""}
                              </td>
                              <td>
                                {(ele &&
                                  ele.quantity
                                    .map((e) => e.subunitValue)
                                    .join(", ")) ||
                                  ""}
                              </td>
                              <td>
                                {(ele &&
                                  ele.quantity
                                    .map((e) =>
                                      e.subUnit == "" ? "-" : e.subUnit,
                                    )
                                    .join(",")) ||
                                  ""}
                              </td>
                              <td>
                                {(ele &&
                                  ele.quantity
                                    .map((e) => e.price)
                                    .join(", ")) ||
                                  ""}
                              </td>
                              <td>{ele.pStatus}</td>
                              <td>{ele.tag}</td>

                              <td>
                                {Number(ele.shelfLife.from) ==
                                Number(ele.shelfLife.to) ? (
                                  <>
                                    {ele.shelfLife.from || ""}{" "}
                                    {ele.shelfLife.days || ""}
                                  </>
                                ) : (
                                  <>
                                    {ele.shelfLife.from || ""} -{" "}
                                    {ele.shelfLife.to || ""}{" "}
                                    {ele.shelfLife.days || ""}
                                  </>
                                )}
                              </td>

                              <td title={ele.productDetails}>
                                {ele.productDetails.length > 20
                                  ? ele.productDetails.substring(0, 30) + "..."
                                  : ele.productDetails}
                              </td>

                              <td title={ele.ingredients}>
                                {ele.ingredients.length > 20
                                  ? ele.ingredients.substring(0, 30) + "..."
                                  : ele.ingredients}
                              </td>

                              <td title={ele.usage}>
                                {ele.usage.length > 20
                                  ? ele.usage.substring(0, 30) + "..."
                                  : ele.usage}
                              </td>
                            </tr>
                          )),
                        )}
                      </tbody>
                    </table>
                  </div>
                </section>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                {data && data.length !== 0 ? (
                  <Pagination
                    dataPerPage={dataPerPage}
                    totalData={data.length}
                    paginate={paginate}
                    currentPage={currentData}
                  />
                ) : (
                  <Fragment />
                )}
              </div>
              <div className="col-lg-11 col-md-6 col-sm-11 col-11 align_right">
                <label>
                  <b>
                    No. of Members :{" "}
                    {newsampadaProductReport && newsampadaProductReport.length}{" "}
                    &nbsp; No. of Products :{" "}
                    {newsampadaProductReport &&
                      newsampadaProductReport.flatMap((e) => e.productDetails)
                        .length}
                  </b>
                </label>
              </div>
            </div>
          </section>
        </div>
      )}
    </Fragment>
  );
};
ProductReport.prototypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  getAllBatchesDropdown: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});
export default connect(mapStateToProps, {
  getBatchOfParish,
  getVarados,
  getParish,
  getModifiedSampadaProductReport,
  getCategoryAndSubcategory,
})(ProductReport);
